// extracted by mini-css-extract-plugin
export var carouselHeader = "CarouselHeader-module--carouselHeader--51daf";
export var carouselHeader__navigation = "CarouselHeader-module--carouselHeader__navigation--ead95";
export var carouselHeader__rotate180 = "CarouselHeader-module--carouselHeader__rotate180--4e737";
export var carouselHeader__title = "CarouselHeader-module--carouselHeader__title--eb71f";